import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=740ab72a&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740ab72a"]])

export default __exports__